/**
 * O que está recolhido na árvore da lista de Itens, guardado no PERFIL da
 * pessoa (SPEC-20261008-1632-arvore-recolhida-no-perfil, pedido do Cristian:
 * "ao recolher a lista de itens ou expandir deve guardar no perfil do usuário
 * e manter a última coisa que ele fez, mesmo saindo e voltando da tela").
 *
 * Guardar a lista de ids recolhidos não cabe: "Recolher tudo" num workspace
 * grande são centenas de ids, e a preferência tem teto de 4 KB. Então guarda
 * o MODO (tudo aberto / tudo recolhido) e só as EXCEÇÕES que a pessoa abriu ou
 * fechou à mão — e item novo já nasce seguindo o modo escolhido.
 */
export type ArvoreGuardada = {
  v: 1
  modo: 'aberto' | 'fechado'
  /** Ids (item ou `cl:<checklist>`) no estado OPOSTO ao do modo. */
  excecoes: string[]
}

export const ARVORE_PADRAO: ArvoreGuardada = { v: 1, modo: 'aberto', excecoes: [] }

/** Cabe no teto da preferência (ids de 36 caracteres + aspas e vírgula). */
export const MAXIMO_DE_EXCECOES = 80

/** Aceita o que veio do banco só se tiver o formato; senão, o padrão. */
export function adotarArvore(bruto: unknown): ArvoreGuardada | null {
  if (typeof bruto !== 'object' || bruto === null) return null
  const v = bruto as { v?: unknown; modo?: unknown; excecoes?: unknown }
  if (v.v !== 1 || (v.modo !== 'aberto' && v.modo !== 'fechado') || !Array.isArray(v.excecoes)) return null
  return {
    v: 1,
    modo: v.modo,
    excecoes: v.excecoes.filter((e): e is string => typeof e === 'string').slice(-MAXIMO_DE_EXCECOES),
  }
}

/** O que a árvore pergunta: este nó está recolhido? */
export function recolhidosDe(arvore: ArvoreGuardada): { has: (id: string) => boolean } {
  const excecoes = new Set(arvore.excecoes)
  return { has: (id) => (arvore.modo === 'aberto' ? excecoes.has(id) : !excecoes.has(id)) }
}

/**
 * Abre ou fecha UM nó: entra (ou sai) das exceções. Passando do teto, as mais
 * antigas caem — voltam a seguir o modo.
 */
export function alternarNaArvore(arvore: ArvoreGuardada, id: string): ArvoreGuardada {
  const excecoes = arvore.excecoes.includes(id)
    ? arvore.excecoes.filter((e) => e !== id)
    : [...arvore.excecoes, id].slice(-MAXIMO_DE_EXCECOES)
  return { ...arvore, excecoes }
}

/** "Recolher tudo" / "Expandir tudo": muda o modo e zera as exceções. */
export function tudoNaArvore(modo: ArvoreGuardada['modo']): ArvoreGuardada {
  return { v: 1, modo, excecoes: [] }
}
